<div aria-label="fax history container" class="p-4">
  <app-fax-history-search-form
    [isLoading]="isLoading"
    (submitSearch)="submitFaxHistorySearch($event)"
  ></app-fax-history-search-form>

  <div [class.table-container]="!!faxHistorySearchResultsList.length">
    <p-table
      #dt
      scrollDirection="vertical"
      scrollHeight="flex"
      styleClass="has-border"
      [alwaysShowPaginator]="false"
      [columns]="columns"
      [filterDelay]="100"
      [globalFilterFields]="filterableFields"
      [loading]="isLoading"
      [nexusGlobalFilterWithDate]="filterTableDateConfig"
      [paginator]="true"
      [rows]="25"
      [scrollable]="true"
      [value]="faxHistorySearchResultsList"
      [(first)]="firstPage"
      >
      <ng-template pTemplate="caption">
        <div class="flex justify-end p-4">
          <p-iconfield>
            <p-inputicon class="pi pi-search" aria-hidden="true" />
            <input
              class="filter-columns"
              pInputText
              placeholder="Filter Across all Columns"
              size="50"
              type="text"
              (input)="dt.filterGlobal($event.target.value, 'contains')"
            />
          </p-iconfield>
        </div>
      </ng-template>
        <ng-template let-columns pTemplate="header">
          <tr>
            <th style="width: 7.2rem; max-width: 8rem"></th>
            @for (col of columns; track col.field) {
              <th
                [pSortableColumn]="col.field"
                [style.min-width]="col.width"
                >
                <div class="flex items-center gap-2">
                  <span>{{ col.header }}</span>
                  @if (col.field !== '') {
                    <p-sortIcon
                      ariaLabel="Activate to sort"
                      ariaLabelAsc="Activate to sort in ascending order"
                      ariaLabelDesc="Activate to sort in descending order"
                      [field]="col.field"
                      >
                    </p-sortIcon>
                  }
                </div>
              </th>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="w-full" colspan="11">No records found</td>
          </tr>
        </ng-template>
        <ng-template let-columns="columns" let-rowData pTemplate="body">
          <tr>
            <td style="max-width: 8rem">
              <button
                class="p-button-primary"
                id="fax-history-resend-button"
                label="Resend"
                pButton
                type="button"
                (click)="resendFax(rowData.faxId)"
              ></button>
            </td>
            <td class="centerdata" [style.min-width]="columns[0].width">
              <div class="truncate">{{ rowData["authNumber"] }}</div>
            </td>
            <td
              class="centerdata"
              tooltipPosition="bottom"
              tooltipStyleClass="tooltip-xl-size"
              [pTooltip]="rowData['createdBy']"
              [style.min-width]="columns[1].width"
              >
              <div class="truncate">
                {{ rowData["createdBy"] }}
              </div>
            </td>
            <td
              class="centerdata"
              tooltipPosition="bottom"
              tooltipStyleClass="tooltip-xl-size"
              [pTooltip]="rowData['providerLocation']"
              [style.min-width]="columns[2].width"
              >
              <div class="truncate">{{ rowData["providerLocation"] }}</div>
            </td>
            <td class="centerdata" [style.min-width]="columns[3].width">
              {{ rowData["recipientFaxNumber"] | faxNumber }}
            </td>
            <td
              class="centerdata"
              tooltipPosition="bottom"
              tooltipStyleClass="tooltip-xl-size"
              [pTooltip]="rowData['subject']"
              [style.min-width]="columns[4].width"
              >
              <div class="truncate">{{ rowData["subject"] }}</div>
            </td>
            <td
              class="centerdata"
              tooltipPosition="bottom"
              tooltipStyleClass="tooltip-xl-size"
              [pTooltip]="rowData['recipientName']"
              [style.min-width]="columns[5].width"
              >
              <div class="truncate">{{ rowData["recipientName"] }}</div>
            </td>
            <td class="centerdata" [style.min-width]="columns[6].width">
              {{ rowData["status"] }}
            </td>
            <td class="centerdata" [style.min-width]="columns[7].width">
              {{ rowData["communicationType"] }}
            </td>
            <td class="centerdata" [style.min-width]="columns[8].width">
              {{ rowData["dateInQueue"] | utcToLocal : "MM/dd/yyyy hh:mm:ss a" }}
            </td>
            <td class="centerdata" [style.min-width]="columns[9].width">
              <div class="truncate">{{ rowData["failReason"] }}</div>
            </td>
          </tr></ng-template
          >
        </p-table>
      </div>
    </div>
